<template>
  <div class="fillSpace">
    <AppMenu>
      <template v-slot:topleft>
        <div class="container-title">
          <RoundButton class="homeButton" href="/" width="60" image="ic-home.svg" />
          <!--          <RoundButton
            class="bordered back"
            href="/"
            :width="currentScreenWidth > 1024 ? 35 : 25"
            image="ic-arrow-back.svg"
          />-->
          <h2 class="titleQuizz">{{ getWebcontrol('RaconterVotreJournee-Titre-RaconterVotreJournee') }}</h2>
        </div>
      </template>
      <template v-slot:bottomrightincontainer>
        <img class="logo-bottom-right" src="../assets/logo.png" />
      </template>
    </AppMenu>
    <h2 class="title-summary" v-show="isLast">Synthèse de votre journée</h2>
    <div class="appcontainer">
      <RoundButton
        v-if="stepNumber === 1 || isLast"
        @go="refresh()"
        :width="currentScreenWidth > 1024 ? 35 : 25"
        image="ic-mode-autorenew.svg"
        class="topRightMenuButton bordered"
      />
      <div v-bind:style="isLast && 'gridColumn: 1 / 5'" class="panel">
        <div v-bind:class="{ 'marge-null': steps[stepNumber - 1]['inputType'] === 'OCQSmall' }" class="titleRelate">
          {{
            isStepTransport
              ? 'QUEL(S) SONT VOS PRINCIPAUX MOYENS DE DÉPLACEMENTS AU QUOTIDIEN ?'
              : steps[stepNumber - 1].title
          }}
        </div>
        <h3 v-if="isStepTransport">2 choix maximum</h3>
        <h3 v-if="steps[stepNumber - 1]['inputType'] === 'OCQSmall'">3 maximum</h3>
        <div v-if="steps[stepNumber - 1]['inputType'] === 'OCQBig'" class="cards">
          <Card
            v-for="(card, index) in steps[stepNumber - 1].cards"
            :type="steps[stepNumber - 1].type"
            :key="index"
            :card="card"
            :stepImg="steps[stepNumber - 1].indexImg"
            :step="stepNumber - 1"
            :index="index"
          />
        </div>
        <div v-if="steps[stepNumber - 1]['inputType'] === 'OCQSmall'" class="smallCards">
          <SmallCard
            v-for="(card, index) in steps[stepNumber - 1].cards"
            :key="index"
            :card="card"
            :step="stepNumber - 1"
            :index="index"
          />
        </div>
        <AgeStep
          v-if="steps[stepNumber - 1]['inputType'] === 'OCQNoImages' && !isStepTransport"
          :step="stepNumber - 1"
          :correctionsByAges="steps[stepNumber - 1].correctionsByAges"
        />
        <TransportsStep v-if="isStepTransport" />
        <SliderStep v-if="steps[stepNumber - 1]['inputType'] === 'slider'" :stepNumber="stepNumber - 1" />
        <ListCheckStep
          v-if="steps[stepNumber - 1]['inputType'] === 'OCQList'"
          :list="steps[stepNumber - 1].cards"
          :step="stepNumber - 1"
        />
        <Summary v-if="isLast" />
      </div>
      <div v-if="this.stepNumber !== this.steps.length" class="progressBar">
        <div v-if="steps[stepNumber - 1].other" class="otherReason">
          <Checkbox @change="checkOtherValue()" :bind="otherCheckBox" />
          <p>{{ steps[stepNumber - 1].other }}</p>
        </div>
        <span v-if="errorDisplayed && !isStepTransport" class="error-message">
          {{
            this.stepNumber === steps.length - 1
              ? 'Vous devez choisir une ou plusieurs réponses pour accéder à la synthèse'
              : 'Vous devez choisir une ou plusieurs réponses pour accéder à la question suivante'
          }}
        </span>
        <span v-if="errorDisplayed && isStepTransport" class="error-message">
          {{ 'Merci de choisir deux réponses maximum pour passer à la question suivante.' }}
        </span>
        <ProgressBar :percent="Math.round((stepNumber * 100) / (steps.length - 1))" />
      </div>
      <div class="manageOverflow" v-if="!isLast">
        <div class="jack">
          <img src="../../src/assets/home1.png" alt="home1" />
        </div>
      </div>
      <div class="footer">
        <p>{{ isLast ? '' : `${this.stepNumber}/${this.steps.length - 1}` }}</p>
        <div class="changeStep">
          <Button
            :reversed="true"
            :isValid="true"
            v-if="stepNumber !== 1"
            text="Précédent"
            v-on:click.native="previousStep()"
          />
          <Button
            v-on:click.native="nextStep()"
            :text="
              stepNumber === steps.length - 1
                ? 'Accéder à votre synthèse'
                : isLast
                ? 'La Recommandation Essilor'
                : 'Suivant'
            "
            :isValid="isLast ? true : this.isValid"
            :step="this.stepNumber"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppMenu from '@Components/Menu.vue';
import RoundButton from '@Components/Menus/RoundButton.vue';
import Card from '@Components/Quizz/Card/Card';
import Checkbox from '@Components/Quizz/Input/Checkbox';
import Button from '@Components/Quizz/Button/Button';
import ProgressBar from '../components/Quizz/ProgressBar/ProgressBar';
import SliderStep from '../components/Quizz/Steps/SliderStep';
import AgeStep from '../components/Quizz/Steps/AgeStep';
import TransportsStep from '../components/Quizz/Steps/TransportsStep';
import ListCheckStep from '../components/Quizz/Steps/ListCheckStep';
import SmallCard from '../components/Quizz/Card/SmallCard';
import Summary from '../components/Quizz/Steps/Summary';

export default {
  components: {
    Summary,
    SmallCard,
    ListCheckStep,
    SliderStep,
    AgeStep,
    ProgressBar,
    Card,
    RoundButton,
    AppMenu,
    Checkbox,
    Button,
    TransportsStep,
  },
  mounted() {
    this.$gtag.pageview({
      page_title: 'Quizz Q1',
      page_path: '/Quizz Q1',
      page_location: window.location.href,
    });
  },
  computed: {
    currentScreenWidth() {
      return window.outerWidth;
    },
    isValid() {
      return this.$store.getters.isValid(this.stepNumber - 1);
    },
    otherCheckBox() {
      return this.$store.getters.getOtherChecked(this.stepNumber - 1);
    },
    dataStep() {
      return this.$store.state.dataStep;
    },
    steps() {
      return this.$store.getters.getSteps;
    },
    stepNumber() {
      return Number(this.$route.params.step);
    },
    isLast() {
      return this.stepNumber === this.steps.length;
    },
    getModels() {
      return this.$store.getters.getModelsFromQuizz;
    },
  },
  watch: {
    $route() {
      if (this.isLast) {
        this.$gtag.pageview({
          page_title: 'Quizz Synthèse',
          page_path: '/Quizz Synthèse',
          page_location: window.location.href,
        });
      } else {
        this.$gtag.pageview({
          page_title: 'Quizz Q' + this.stepNumber,
          page_path: '/Quizz Q' + this.stepNumber,
          page_location: window.location.href,
        });
      }
    },
  },
  methods: {
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
    refresh() {
      this.$store.dispatch('resetState');
      this.$router.push('/relate/1');
    },
    previousStep() {
      if (this.stepNumber === 2 && this.isStepTransport) {
        this.isStepTransport = false;
        return;
      } else if (this.stepNumber === 3) {
        this.isStepTransport = true;
      }
      this.$router.push('/relate/' + String(this.stepNumber - 1)).catch(err => {
        this.$log.error(err);
      });
    },
    nextStep() {
      this.errorDisplayed = false;
      this.messageError = null;

      //étape pour les transports
      if (this.stepNumber === 2 && !this.isStepTransport && this.$store.getters.isValid(this.stepNumber - 1)) {
        this.isStepTransport = true;
        return;
      } else if (this.stepNumber === 2 && this.isStepTransport && this.$store.getters.isValid(this.stepNumber - 1)) {
        if (!this.$store.getters.isStepTransportValid) {
          this.errorDisplayed = true;
          return;
        }
        this.isStepTransport = false;
        this.$store.dispatch('deactivatesTransports');
        return this.$router.push('/relate/' + String(this.stepNumber + 1)).catch(err => {
          this.$log.error(err);
        });
      }

      //dernière étape
      if (this.isLast) {
        this.$store.dispatch('QuizzFilled', true);
        return this.$router.push({ path: '/demos/configurator', query: this.getModels });
      }

      //étape suivante
      this.$store.getters.isValid(this.stepNumber - 1)
        ? this.$router.push('/relate/' + String(this.stepNumber + 1)).catch(err => {
            this.$log.error(err);
          })
        : (this.errorDisplayed = true);
    },
    checkOtherValue() {
      this.$store.dispatch('setCheckedOther', this.stepNumber - 1);
    },
  },
  data: () => {
    return {
      isStepTransport: false,
      errorDisplayed: false,
      messageError: null,
    };
  },
};
</script>

<style scoped>
.fillSpace {
  width: 100%;
  height: 100%;
}

.container-title {
  display: flex;
  display: -moz-flex;
  display: -webkit-flex;
}

.titleQuizz {
  padding-left: 20px;
}

.appcontainer {
  position: absolute;
  top: 10vh;
  bottom: 10vh;
  left: 7vw;
  right: 7vw;
  min-height: 71vh;
  justify-content: center;
  align-items: center;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 3fr 0.2fr 0.5fr;
  -ms-grid-rows: 3fr 0.5fr 0.5fr;
  -ms-grid-columns: minmax(10px, 58em);
  padding: 1% 5% 2%;
  background-color: rgba(255, 214, 24, 0.2);
}
.panel {
  margin-top: 2%;
  z-index: 1;
  grid-row: 1;
  -ms-grid-row: 1;
  grid-column: 1 / 4;
  -ms-grid-column: 1;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.titleRelate {
  align-self: self-start;
  justify-self: left;
  margin-bottom: 1vw;
  display: flex;
  white-space: nowrap;
  text-align: start;
  text-transform: uppercase;
  font-size: 43px;
}
.progressBar {
  align-self: self-end;
  grid-row: 2;
  -ms-grid-row: 2;
  -ms-grid-column: 1;
  grid-column: 1 / 4;
  width: 100%;
}
.manageOverflow {
  overflow: hidden;
  bottom: 0;
  right: 3vw;
  position: absolute;
}
.title-summary {
  text-align: center;
  height: 70px;
}
.jack {
  transform: scaleX(-1);
}
.jack img {
  width: 19vw;
}
.otherReason {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.otherReason p {
  padding-top: 10px;
}
.footer {
  align-self: self-end;
  display: inline-flex;
  grid-column: 1 / 4;
  grid-row: 3;
  -ms-grid-row-span: 2;
  -ms-grid-column: 1;
  -ms-grid-column-span: 2;
  -ms-grid-row: 3;
  align-items: center;
}
.changeStep {
  z-index: 1;
  position: absolute;
  left: 30%;
  display: flex;
  bottom: 2.5%;
}
.cards {
  display: flex;
}
.smallCards {
  display: flex;
  flex-wrap: wrap;
}
p {
  margin: 0;
}
.error-message {
  font-style: italic;
  color: red;
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
}

@media only screen and (max-width: 1750px) {
  .titleRelate {
    font-size: 35px;
  }
}

@media only screen and (max-width: 1431px) {
  .titleRelate {
    font-size: 25px;
  }
}

@media only screen and (max-width: 1024px) {
  .titleRelate {
    font-size: 17px;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  .panel {
    margin-bottom: 50%;
  }
  .changeStep {
    margin-left: 30%;
  }
  .manageOverflow {
    height: 40vh;
  }
}
h2 {
  display: flex;
  justify-content: center;
  align-items: center;
}
h3 {
  text-shadow: 0.2px 0 black;
  text-align: left;
}

.topRightMenuButton {
  position: absolute;
  top: 2%;
  right: 2%;
}

.marge-null {
  margin: 0;
}
.back:hover {
  border: 1px solid black;
}
</style>
